<template>
  <v-card ref="ContenedorPrimario" class="d-flex flex-column content-container pa-1">
    <!-- Título -->
    <div ref="Titulo" class="text-h6 font-weight-bold mb-2 text-center">
      <v-row ref="SeccionBuscar" class="ma-0 pa-0" no-gutters>

        <v-col id="lbl_Titulo" :cols="bRequiere_VG? 10:12" :md="6" class="pt-0 pb-2">
          {{ titulo }}
        </v-col>

        <v-col  v-if="bRequiere_VG" id="seccion_ConfigVG" cols="2" md="6" class="pt-0 pb-2">
            <v-icon id="icon_configVG" x-large @click="bShowConfigGV = !bShowConfigGV" >mdi-cog-outline</v-icon>
        </v-col>
      </v-row>  
    </div>

    <!-- Encabezado responsivo: Buscador + Botón -->
    <v-row ref="ContenedorBuscador" class="ma-0 pa-0" no-gutters>
      <!-- Buscador -->
      <v-col cols="12" md="6" class="px-4 pt-0 pb-1 pb-md-2">
        <v-text-field id="input_Buscarproceso" dense outlined hide-details
          v-model="sLlave"
          :label="placeholderBusqueda"
          clearable
          append-icon="mdi-magnify"
          @click:append="buscar"
          @click:clear="clearBuscar"
        />
      </v-col>

      <!-- Botón (aparece arriba -->
      <v-col cols="12" md="4" class="d-flex px-4 pt-8 pt-md-0 pb-8" >
        <v-btn v-if="cmp_VariableGloba" id="Btn_NuevoProcesoArriba"  block color="primary" class="white--text" @click="nuevoProceso">
          NUEVO PROCESO 
        </v-btn>
      </v-col>
    </v-row>

    <!-- Zona scrollable (importante: flex para que overflow funcione) -->
    <div class="list-wrapper" ref="scrollContainer">
      <ListCardProceso id="ListaProcesos"
        v-if="items.length"
        :items="items"
        @seleccionado="mostrarDetalle"
        />
        <!-- @load-more="loadProcesos" -->
      <div v-if="loading" class="text-center pa-4">
        Cargando más procesos...
      </div>
      <div v-if="!loading && !items.length" class="text-center text-grey pa-4">
        No hay procesos registrados
      </div>
    </div>

      <ConfigGV_Proceso
        id="configGFProcesos_componente"
        v-model="bShowConfigGV"
        :tituloProceso="titulo"  
        :nIdProceso="nIdProceso"
        :nIdFormulario="getaInfoProceso?.constGlobales?.form_id"
        :dataMap="getaInfoProceso?.constGlobales?.mapping || {}"
        @bConfig="validarConfig"
      />
  </v-card>
</template>

<script>
import axiosServices from "@/services/axiosServices.js"
import ListCardProceso from "@/components/workflow/ListCardProceso.vue";
import ConfigGV_Proceso from "@/components/workflow/ConfigGV_Proceso.vue";
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  name: "ProcesoDetalle",
  components: { ListCardProceso, ConfigGV_Proceso },
  props: {
  },
  data() {
    return {
      titulo: `Proceso `  ,
      nIdProceso: 0,
      sLlave: "",
      items : [],
      placeholderBusqueda: "Escriba la llave para buscar" ,
      nKey: 0,
      aInfoProceso : [],
      page: 1,
      loading: false,
      allItemsLoaded: false,
      pageSize: 30,
      bRequiere_VG: true , // indica si se requiere configurar variable global
      bConfig_VG: false  , // india si se cuenta con la Variable global configurada
      bShowConfigGV : false,
    };
  },
  async mounted() {
      if (this.$route.name === 'ProcesoDetalle') {
      history.pushState(null, null, location.href);
      this._preventBack = () => {
        if (!window.__workflowGoingBack) {
          history.pushState(null, null, location.href);
        }
        window.__workflowGoingBack = false;
      };
      window.addEventListener('popstate', this._preventBack);
      this.$store.dispatch('setbNavegacion', true);
      this.$store.dispatch('setNavegacionBack', 'Listarprocesos');
    }

    this.titulo = this.$route.params.NombreProceso.replace(/_/g, ' ').toUpperCase()
    
    if (Object.keys(this.$route.params).length > 0) {
      this.nIdProceso = parseInt(this.$route.params.idProceso)
    }else{
      this.nIdProceso = this.getIdProceso
    }

    // obtengo los datos del proceso para su gestion
    const oResponse = await axiosServices.getConfiguration(`workflow/${this.nIdProceso}/informacion`, true )

    if(oResponse.nStatusCode === 200 ){
      this.aInfoProceso = oResponse.aData
      this.$store.dispatch("str_Procesos/pushaInfoProceso", this.aInfoProceso);
      

      //valido si se manejan Variables globales
      this.bRequiere_VG =  true
      this.bConfig_VG   = false
      if(oResponse.aData?.constGlobales.form_id ) {
        this.set_VariableGlobal()
      } else {
        this.bRequiere_VG = false 
      }
    }

    this.loadProcesos();

  
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this._preventBack);
    this.$store.dispatch('setbNavegacion', false);
  },
  computed: {
    cmp_VariableGloba() {
      if (!this.bRequiere_VG) return true
      return this.bRequiere_VG && this.bConfig_VG 
    },

    ...mapGetters('str_Procesos', ['getaInfoProceso','getoVariablesGlobales_Filter', 'getFiltrosGlobales'])
  },
  methods: {
    async loadProcesos() {

      // if (this.loading || this.allItemsLoaded) return;
      this.loading = true;



      const url = `workflow/${this.nIdProceso}/buscar`;
      const requestParams = `pagina=${this.page}&noRegistros=${this.pageSize}`;

      let oBody = {sLlave: ""};

      if (this.sLlave) {
        oBody.sLlave = this.sLlave;
      }

      // manejo de solicitudes cuando se tiene variables globales
      const oInfoProceso = this.getaInfoProceso;
      if (oInfoProceso && oInfoProceso.constGlobales) {
        const oVariablesGlobales = await this.getoVariablesGlobales_Filter(this.nIdProceso);
        if (Object.keys(oVariablesGlobales).length > 0) {
          oBody= {
            ...oBody,
            oVariablesGlobales : await this.__prepararFiltroGlobales(oVariablesGlobales)
          };
        }
      } 


      try {
        const oResponse = await axiosServices.postConfiguration(url, oBody ,true, requestParams);
        if (oResponse.nStatusCode === 200 && oResponse.aData) {
          this.items = oResponse.aData
          this.allItemsLoaded = true;

          // if (oResponse.aData.length > 0) {
          //   // this.items.push(...oResponse.aData);
          //   this.page++;
          // } else {
          //   this.items = []
          // }
          // if (oResponse.aData.length < this.pageSize) {
          //   this.allItemsLoaded = true;
          // }
        } else {
          this.allItemsLoaded = true; // Stop trying on error or no data
        }
      } catch (error) {
        console.error("Error loading processes:", error);
        this.allItemsLoaded = true; // Stop trying on exception
      } finally {
        this.loading = false;
        // After loading is done and data is potentially updated, check for scrollbar
        this.$nextTick(() => {
          const container = this.$refs.scrollContainer;
          if (container && container.scrollHeight <= container.clientHeight && !this.allItemsLoaded) {
            this.loadProcesos();
          }
        });
      }
    },

    async __prepararFiltroGlobales (oVariablesGlobales) {
      
      const filtroGV = await this.getFiltrosGlobales
      const filtrosNormalizados = new Set(filtroGV.map(filtros => filtros.toLowerCase()));

      return  await Object.fromEntries(
        Object.entries(oVariablesGlobales).filter(([clave]) =>
          filtrosNormalizados.has(clave.toLowerCase())
        )
      );

    },

    clearBuscar() {
      this.sLlave = '';
      this.buscar();
    },

    async buscar() {
      this.items = [];
      this.page = 1;
      this.allItemsLoaded = false;
      // The following line is important to scroll to top before new search
      if (this.$refs.scrollContainer) this.$refs.scrollContainer.scrollTop = 0;
      await this.loadProcesos();
    },

    mostrarDetalle(proceso) {
      this.$router.replace({
        name   : 'ProcesoViewDetalle', 
        params : { NombreProceso: this.$route.params.NombreProceso, nIdProceso: this.nIdProceso, id: proceso.id },
        query  : { infoProceso: proceso } 
      })
    },

    nuevoProceso() {
      const aTransitions = Object.keys(this.aInfoProceso.Transitions)
      this.$router.replace({
        name   : 'ProcesoNewForm', 
        params : { 
            NombreProceso: this.$route.params.NombreProceso,
            idProceso: this.$route.params.idProceso,
            idFormulario: this.aInfoProceso.Transitions[aTransitions[0]].form_id,
          },
      })
    },
    set_VariableGlobal() {
      // valido que se tengan las varaibles globales sino se pide el form indicado
      const oGV = this.getoVariablesGlobales_Filter(this.nIdProceso)
      if(Object.keys(oGV).length !== 0){
        this.bConfig_VG = true
      } else {
        this.$swal({
          timer: 3000,
          icon:  `warning`,
          title: `Pendiente Configuración`,
          text: `Requiere configurar el Proceso.`,
          showConfirmButton: true,
        })
        this.bConfig_VG = false
      }


    },
    validarConfig(){
      // si se recibe este evento fue por que se almaceno la VG en storage.
      this.bConfig_VG = true
       this.$nextTick(() => {
        this.loadProcesos()
       })
    }
  }
};
</script>

<style scoped>
.content-container { 
  /* Altura total = 100vh - Header(60px approx) - Footer(50px) */
  height: calc(100vh - 110px); 
  max-height: calc(100vh - 110px);
  overflow: hidden;
  width: 100%;
}

/* Zona scrollable que ocupa el espacio restante entre header y botón */
.list-wrapper {
  flex: 1 1 auto; /* ocupa el espacio disponible */
  min-height: 0;  /* clave: permite que el overflow funcione dentro de flex */
  overflow-y: auto;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 100px; /* Espacio para botón fijo + footer */
}

.container-btn-new {
  position: fixed;
  bottom: 50px; /* Altura del NavBarFooter aprox */
  left: 0;
  right: 0;
  background-color: white; /* O el color de fondo de la tarjeta */
  padding-top: 5px;
  padding-bottom: 5px;
  z-index: 5;
  box-shadow: 0px -2px 4px rgba(0,0,0,0.1);
}

/* Ajuste de padding interno del text-field (scoped deep selector) */
.search-field >>> .v-input__slot {
  padding-left: 10px;
  padding-right: 8px;
}
</style>
